export default {
    PRODUCTION: 'production',
    DEVELOPMENT: 'development',
};
